import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { switchMap, catchError, map } from 'rxjs/operators';
import {
  RolesActionTypes,
  LoadRolesSuccess,
  LoadRolesFailed,
} from './roles.actions';
import { UserService } from '@account-users/user/services/user.service';
import { IUserRole } from '@account-users/user/models/UserRole';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RolesEffects {
  @Effect()
  fethAllUserRoles = this.actions$.pipe(
    ofType(RolesActionTypes.LoadRoles),
    switchMap(() => {
      return this.userService.fetchUserRoles().pipe(
        map((roles: IUserRole[]) => {
          return new LoadRolesSuccess(roles);
        }),
        catchError((error) => {
          this.toastr.error('Could not fetch user roles', 'Request failed');
          console.error(error);
          return [new LoadRolesFailed()];
        }),
      );
    }),
  );

  constructor(
    private toastr: ToastrService,
    private actions$: Actions,
    private userService: UserService,
  ) {}
}
